// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yCSq","rootNoMargin":"styles_rootNoMargin__2hDGk"};